// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".trend[data-v-19bf82fe]{background:linear-gradient(90deg,rgba(73,74,98,.3),rgba(108,111,157,.2));width:430px;height:299px;border-radius:10px;padding-top:10px;padding-left:35px;box-sizing:border-box}.trend h2[data-v-19bf82fe]{color:#f1edff;font-family:YouSheBiaoTiHei;margin-bottom:20px;font-size:24px;height:31px;text-align:left;text-shadow:0 2px 20px #2a38b4}.box[data-v-19bf82fe]{width:350px;height:215px}", ""]);
// Exports
module.exports = exports;
